var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "reloadTitleId"
  }, "Reload with a new seed.") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "reloadTitleId"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-70.7,-71.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7,80.2C87.8,80.2 78.2,89.8 78.2,101.7C78.2,113.6 87.8,123.2 99.7,123.2C109.5,123.2 117.8,116.7 120.3,107.8L127,107.8C124.3,120.4 113,129.7 99.7,129.7C84.3,129.7 71.7,117.2 71.7,101.7C71.7,86.3 84.2,73.7 99.7,73.7C109.9,73.7 118.8,79.1 123.7,87.3L123.7,77.2C123.7,75.6 125,74.2 126.7,74.2C127.5,74.2 128.2,74.5 128.8,75.1C129.3,75.6 129.7,76.4 129.7,77.2L129.7,98.2L108.8,98.2C108,98.2 107.3,97.9 106.7,97.3C106.1,96.7 105.8,96 105.8,95.2C105.8,93.6 107.1,92.2 108.8,92.2L119,92.2C115.4,85.1 108.2,80.2 99.7,80.2Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.19a777e7.svg";
export { ForwardRef as ReactComponent };